// src/components/onboarding/ReadyScreen.js
import React from 'react';

const ReadyScreen = ({ onTakeTour, onExplore }) => {
  return (
    <div className="space-y-8 text-center py-12">
      {/* Headline */}
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-gray-900">
          Your dashboard is ready.
        </h1>
        <p className="text-sm text-gray-600 max-w-md mx-auto">
          You've got everything you need to start building your practice.
        </p>
      </div>

      {/* Primary Action */}
      <div className="pt-8">
        <button
          onClick={onTakeTour}
          className="w-full max-w-xs mx-auto block px-6 py-3 text-sm font-semibold text-white bg-purple-600 hover:bg-purple-700 rounded-lg transition-colors shadow-md hover:shadow-lg"
        >
          Take a Quick Tour
        </button>
      </div>

      {/* Secondary Action */}
      <div className="pt-2">
        <button
          onClick={onExplore}
          className="text-sm text-gray-600 hover:text-purple-600 transition-colors"
        >
          I'll explore on my own
        </button>
      </div>
    </div>
  );
};

export default ReadyScreen;
